<template>
  <el-select
    v-model="valueBackup"
    placeholder="请输入课程白名单名称进行搜索"
    filterable
    remote
    :remote-method="handleRemote"
    :loading="isLoading"
    :clearable="clearable"
    @change="handleChange"
  >
    <el-option
      v-for="v in listBackup"
      :key="v.id"
      :label="v.course_whitelist_name"
      :value="v.id"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-whitelist';

export default {
  props: {
    value: [Number, String],
    list: {
      type: Array,
      default: () => [],
    },
    clearable: Boolean,
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    isLoading: false,
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
    list(list) {
      if (JSON.stringify(list) !== JSON.stringify(this.listBackup)) this.listBackup = list || [];
    },
  },
  methods: {
    handleChange(valueBackup) {
      if (!valueBackup.length) return;

      for (let i = 0; i  < this.listBackup.length; i++) {
        if (this.listBackup[i].id === valueBackup[0]) return this.$emit('itemChange', this.listBackup[i]);
      }
    },
    async getList(keyword) {
      this.isLoading = true;
      const { isError, data } = await index({ keyword, is_disable_count: 1 });
      this.isLoading = false;
      if (!isError) this.listBackup = data;
    },
    handleRemote(keyword) {
      if (keyword) return this.getList(keyword);

      this.list = [];
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    if (this.list.length) {
      return this.listBackup = this.list;
    }

    this.getList('');
  },
};
</script>
